<div class="service-container">
    <table mat-table [dataSource]="params" aria-label="Tabla de servicios">
        <ng-container matColumnDef="Description">
            <th mat-header-cell *matHeaderCellDef> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.Description}} </td>
        </ng-container>

        <ng-container matColumnDef="Value">
            <th mat-header-cell *matHeaderCellDef> Valor actual </th>
            <td mat-cell *matCellDef="let element"> <input [(ngModel)]="element.Value" type="text" value="{{element.Value}}"> </td>
        </ng-container>

        <ng-container matColumnDef="button">
            <th mat-header-cell *matHeaderCellDef> Actualizar </th>
            <td mat-cell *matCellDef="let element"><button type="submit" (click)="updateRow(element)">Actualizar parametro</button> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator>
</div>
